module.exports = __webpack_public_path__ + "static/media/attendees.833524a8.png";